const range = (start, end, step = 1) => {
    const length = (Math.max(start, end) - Math.min(start, end)) / Math.abs(step);
    return Array.from({ length }, (_, i) => start + i * step);
};
const trimDomain = (val) => {
    return Math.min(Math.max(val, 0.0), 6.0);
};
function calcScale(score, cut, SEM) {
    const ranges = [...range(7, -1, -1).map((n) => cut - n * SEM), 161];
    const scaledVals = range(120, 210, 10);
    score = Math.min(Math.max(score, 0), 160);
    for (let idx = 0; idx < ranges.length; ++idx) {
        const n = ranges[idx];
        if (score < n) {
            return scaledVals[idx];
        }
    }
    return 120;
}
export function scoreExam(exam, rawscores, scoreKeys, scoring) {
    const stats = scoring[exam.toUpperCase()];
    const results = {
        scaled: calcScale(rawscores.score, stats.cut, stats.SEM)
    };
    for (const sub of scoreKeys) {
        const raw = rawscores[sub];
        const cut = stats.domainCut[sub];
        const SEM = stats.domainSEM[sub];
        results[sub] = trimDomain((raw - cut) / SEM + 3);
    }
    return results;
}
